module.exports = __webpack_public_path__ + "img/backtoTop.dad950a.png";